import { PartnerAggregateTab, type PartnerAggregateConfig } from '@/components/PartnerAggregateTab'

const CONFIG: PartnerAggregateConfig = {
  entityShort: '출고',
  entityLabel: '거래처',
  entityNo: '출고번호',
  searchPlaceholder: '품목·출고번호 검색',
  partnerFilterPlaceholder: '전체 거래처',
  emptyDetailText: '이 거래처의 출고 라인이 없습니다.',

  summaryApi: '/api/delivery/partner-summary',
  summaryExportApi: '/api/delivery/partner-summary/export',
  detailExportApi: '/api/delivery/partner-detail/export',
  detailApi: '/api/sales-report',
  detailAcceptsSort: true,
  queryKeyPrefix: 'partner-summary',
  excelFilePrefix: '출고현황_거래처별',

  linkPath: '/main/delivery',
}

export function DeliveryByPartnerTab() {
  return <PartnerAggregateTab config={CONFIG} />
}
